﻿export class Breadcrumb {
    /**
     * Indicates whether an element is overflowing.
     * @param element the element to check.
     * @returns true is it's overflowing
     */
    public IsOverflowing(element: HTMLElement): boolean {
        if (!element) {
            return false;
        }

        let items = element.querySelectorAll(".breadcrumb-v2__item, .breadcrumb-v2__item--interactible");
        if (items.length < 2) return false; // No need to collapse a single item

        let firstRowTop = (items[0] as HTMLElement).offsetTop;

        for (let i = 1; i < items.length; i++) {
            if ((items[i] as HTMLElement).offsetTop !== firstRowTop) {
                return true; // Items wrapped to a new row
            }
        }

        return false; // No wrapping detected

    }
}

window['Breadcrumb'] = new Breadcrumb();